var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "550.1px",
    height: "552px",
    viewBox: "0 0 550.1 552",
    style: {
      enableBackground: "new 0 0 550.1 552"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333745;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "squares_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.9,16.5H213.2v320.3h320.3v-237C533.7,54.9,496.9,16.5,451.9,16.5z M139.9,16.5h-40 c-45,0-83.5,36.6-83.5,83.5v40h123.5V16.5z M16.4,215h123.5v123.5H16.4V215z M410.2,535.3h40c45,0,83.5-36.6,83.5-83.5v-39.9H410.2 L410.2,535.3L410.2,535.3z M213.2,411.9h123.5v123.5H213.2V411.9z M16.4,411.9v40c0,45,36.6,83.5,83.5,83.5h40V411.9H16.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.a1108715718982966acc3d4e8be61e53.svg";
export { ForwardRef as ReactComponent };